<div class="spinner" [hidden]="showSpinner" [class.text-center]="textCenter">
  <i class="fa fa-spinner fa-pulse spinner-icon"></i>
</div>
